var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVelog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "velog",
    d: "M3,0A2.993,2.993,0,0,0,0,3V21a2.993,2.993,0,0,0,3,3H21a2.993,2.993,0,0,0,3-3V3a2.993,2.993,0,0,0-3-3ZM9.883,6.25a1.026,1.026,0,0,1,1.125.9l1.463,8.3q.7-.922,1.146-1.553A14.1,14.1,0,0,0,14.9,11.627a5.464,5.464,0,0,0,.608-2.3,1.357,1.357,0,0,0-.338-.967A5.813,5.813,0,0,0,13.977,7.4a2.753,2.753,0,0,1,2.25-1.148,1.712,1.712,0,0,1,1.193.428,1.572,1.572,0,0,1,.494,1.26,7.591,7.591,0,0,1-1.17,3.488,53.238,53.238,0,0,1-4.431,6.232l-2.227.156L8.375,8.186H6.125V7.24q.9-.293,2.115-.63a7.262,7.262,0,0,1,1.643-.36Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelog);
export default __webpack_public_path__ + "static/media/velog.44c51266a88e04da7987c1f79e9af1b4.svg";
export { ForwardRef as ReactComponent };